import {StateParams} from 'angular-ui-router';
import {NavigationService} from "../../Services/NavigationService";
import {AbsenceDataService} from "../../Services/AbsenceDataService";
import {EStatus, ETransmissionUnit, ITimeBookingVm, ITimeEntryTypeVm} from "../../Data/Data";
import {TimeEntryDataService} from "../../Services/TimeEntryDataService";

export class AbsenceListController {
  static controllerId = "AbsenceListController";
  static $inject = [
    '$stateParams',
    NavigationService.serviceId,
    TimeEntryDataService.serviceId,
    AbsenceDataService.serviceId,
  ];

  userId: number;
  absences: ITimeBookingVm[] = [];
  entryTypes: ITimeEntryTypeVm[] = [];
  loading = true;

  constructor($stateParams: StateParams,
              private navigation: NavigationService,
              private timeEntryData: TimeEntryDataService,
              private absenceData: AbsenceDataService) {
    this.userId = $stateParams['userId'];
    this.timeEntryData.getEntryTypes().then(entryTypes => {
      this.entryTypes = entryTypes;
    });
    this.absenceData.browse(this.userId).then(absences => {
      this.absences = absences;
      this.loading = false;
    });
  }

  goBack() {
    this.navigation.goToMenu();
  }

  isHoliday(absence: ITimeBookingVm) {
    for (const type of this.entryTypes) {
      if (type.id === absence.timeEntryTypeId &&
        type.unit === ETransmissionUnit.Days) {
        return true;
      }
    }
    return false;
  }

  // does not work for 1 day holidaybookings (usually from xx.xx.xxxx:00:00 - xx.xx.xxxx:23:58)
  // currently fixed serverside by shifting the bookings by 6h
  // replace with actual duration check ( dur <= 12h half day, dur > 12 full day)
  getHolidayRange(absence: ITimeBookingVm) {
    if (absence.from.getDate() !== absence.to.getDate()) {
      return 'Volltag';
    } else {
      return 'Halbtag';
    }
  }

  openDetail(absence: any) {
    this.navigation.goToState('absence-detail', {
      absenceId: absence ? absence.id : null,
      userId: this.userId,
    });
  }

  getStatusClass(absence: ITimeBookingVm) {
    if (absence.status === EStatus.Failed) {
      return 'status-red';
    } else if (absence.status === EStatus.Pending) {
      return 'status-yellow';
    } else {
      return 'status-green';
    }
  }
}
